import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE } from '../api';
import MapaFichajes from './MapaFichajes';

function InformeAdmin({ token }) {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = React.useRef();
  const [exportModal, setExportModal] = useState(false);
  const [exportDesde, setExportDesde] = useState('');
  const [exportHasta, setExportHasta] = useState('');
  const [exportando, setExportando] = useState(false);

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    }
    if (dropdownVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownVisible]);

  const empleadosAnim = `@keyframes fadeScale {
    0% { opacity: 0; transform: scale(0.92) translateY(-10px); }
    60% { opacity: 1; transform: scale(1.04) translateY(0); }
    100% { opacity: 1; transform: scale(1) translateY(0); }
  }`;
  const [busquedaEmpleado, setBusquedaEmpleado] = useState('');
  const [infoIdx, setInfoIdx] = useState(null);
  const warningAnim = `@keyframes warningFade {
    0% { opacity: 0; transform: scale(0.8) translateY(-20px); }
    60% { opacity: 1; transform: scale(1.08) translateY(0); }
    80% { transform: scale(0.98) translateY(-6px); }
    100% { opacity: 1; transform: scale(1) translateY(0); }
  }`;
  const [fichajes, setFichajes] = useState([]);
  const [formato, setFormato] = useState('pdf');
  const [tipoInforme, setTipoInforme] = useState('admin');
  const [usuarios, setUsuarios] = useState([]);
  const [usuariosFiltro, setUsuariosFiltro] = useState([]);
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');
  const [mapaVisible, setMapaVisible] = useState(false);
  const [mapaModal, setMapaModal] = useState(false);
  const [settingsEmpresa, setSettingsEmpresa] = useState(null);

  React.useEffect(() => {
    axios.get(`${API_BASE}/api/settings`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setSettingsEmpresa(r.data))
      .catch(() => {});
  }, [token]);

  React.useEffect(() => {
    async function fetchUsuarios() {
      try {
        const apiUrl = `${API_BASE}/api/admin/usuarios`;
        const res = await axios.get(apiUrl, { headers: { Authorization: `Bearer ${token}` } });
        setUsuarios(res.data);
      } catch (err) {
        setUsuarios([]);
      }
    }
    fetchUsuarios();
  }, [token]);

  let usuariosFiltrados = [];
  if (usuarios && Array.isArray(usuarios)) {
    usuariosFiltrados = usuarios.filter(u => {
      const texto = `${u.nombre} ${u.apellidos} ${u.email}`.toLowerCase();
      return texto.includes(busquedaEmpleado.toLowerCase());
    });
  }

  const consultar = async () => {
    try {
      let apiUrl = `${API_BASE}/api/fichaje/informe?`;
      if (usuariosFiltro.length > 0) {
        apiUrl += `usuarios=${usuariosFiltro.join(',')}&`;
      }
      if (desde) apiUrl += `desde=${encodeURIComponent(desde)}&`;
      if (hasta) apiUrl += `hasta=${encodeURIComponent(hasta)}&`;
      const res = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const ordenados = res.data.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
      setFichajes(ordenados);
    } catch (err) {
      setFichajes([]);
      console.error('Error al consultar informe:', err);
    }
  };

  const exportar = async (fechaDesde, fechaHasta) => {
    setExportando(true);
    try {
      let exportUrl = `${API_BASE}/api/fichaje/export?formato=${formato}`;
      exportUrl += `&tipoInforme=${tipoInforme}`;
      if (usuariosFiltro.length > 0) {
        exportUrl += `&usuarios=${usuariosFiltro.join(',')}`;
      }
      if (fechaDesde) exportUrl += `&desde=${encodeURIComponent(fechaDesde)}`;
      if (fechaHasta) exportUrl += `&hasta=${encodeURIComponent(fechaHasta)}`;
      const res = await axios.get(exportUrl, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });
      const contentType = res.headers['content-type'] || (formato === 'excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/pdf');
      const blob = new Blob([res.data], { type: contentType });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `informe_${tipoInforme}_${new Date().toISOString().slice(0,10)}.${formato === 'excel' ? 'xlsx' : 'pdf'}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setExportModal(false);
    } catch (err) {
      console.error('Error al exportar informe:', err);
      alert('Error al exportar el informe.');
    } finally {
      setExportando(false);
    }
  };

  const groupByDay = (fichajes) => {
    const days = {};
    fichajes.forEach(f => {
      const day = new Date(f.fecha).toLocaleDateString();
      if (!days[day]) days[day] = [];
      days[day].push(f);
    });
    return days;
  };

  const fontFamily = 'Quicksand, Montserrat, Arial, sans-serif';

  return (
    <div style={{maxWidth:900,margin:'1em auto',fontFamily,padding:'0 0.75em',boxSizing:'border-box'}}>
      <style>{`
        @media (max-width: 600px) {
          .ia-h2 { font-size: 1.3rem !important; margin-bottom: 0.8em !important; }
          .ia-filter-panel { padding: 1.1em 0.9em !important; gap: 1em !important; }
          .ia-action-bar { padding: 0.9em !important; flex-direction: column !important; align-items: stretch !important; }
          .ia-action-bar select { width: 100%; }
          .ia-action-bar-inner { flex-direction: column !important; gap: 0.6em !important; align-items: stretch !important; }
          .ia-action-bar-inner select { flex: unset !important; }
          .ia-action-bar button { width: 100% !important; }
          .ia-card { padding: 1em !important; }
          .ia-day-label { font-size: 1em !important; }
          .ia-cards-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
      <h2 className="ia-h2" style={{textAlign:'center',color:'#1976d2',fontWeight:700,marginBottom:'1.2em',fontFamily,fontSize:'clamp(1.3rem, 5vw, 2rem)'}}>Informe de fichajes (admin)</h2>
      <div className="ia-filter-panel" style={{
        display:'flex',
        flexDirection:'column',
        gap:'1.5em',
        marginBottom:'1.5em',
        background:'linear-gradient(135deg, rgba(25, 118, 210, 0.05) 0%, rgba(144, 202, 249, 0.08) 100%)',
        borderRadius:'20px',
        border:'2px solid rgba(25, 118, 210, 0.15)',
        boxShadow:'0 4px 20px rgba(25, 118, 210, 0.1)',
        padding:'1.8em 1.5em',
        boxSizing:'border-box'
      }}>
        <style>{empleadosAnim}</style>
        <div style={{fontWeight:500, position:'relative', width:'100%'}} ref={dropdownRef}>
          <div style={{marginBottom:'0.8em',fontSize:'1.1em',color:'#1976d2',fontWeight:700}}>👥 Empleados</div>
          <div style={{marginTop:'0.5em'}}>
            <input
              type="text"
              placeholder="🔍 Buscar empleado..."
              value={busquedaEmpleado}
              onChange={e => setBusquedaEmpleado(e.target.value)}
              style={{
                width:'100%',
                padding:'0.7em 1em',
                borderRadius:12,
                border:'2px solid #90caf9',
                fontFamily,
                marginBottom:'0.7em',
                fontSize:'1rem',
                transition:'all 0.3s',
                outline:'none',
                boxSizing:'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#1976d2'}
              onBlur={(e) => e.target.style.borderColor = '#90caf9'}
            />
            <label style={{
              display:'flex',
              alignItems:'center',
              gap:'0.5em',
              fontWeight:600,
              padding:'0.5em 1.2em',
              cursor:'pointer',
              background:'rgba(25, 118, 210, 0.08)',
              borderRadius:10,
              marginBottom:'0.5em',
              transition:'background 0.2s',
              boxSizing:'border-box'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(25, 118, 210, 0.15)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(25, 118, 210, 0.08)'}
            >
              <input
                type="checkbox"
                checked={usuariosFiltro.length === usuariosFiltrados.length}
                onChange={e => {
                  if (e.target.checked) {
                    setUsuariosFiltro(usuariosFiltrados.map(u => u._id));
                  } else {
                    setUsuariosFiltro([]);
                  }
                }}
                style={{width:18,height:18,cursor:'pointer',flexShrink:0}}
              />
              <span style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',color:'#1e293b'}}>Seleccionar todos</span>
            </label>
            <div style={{
              maxHeight:'200px',
              overflowY:'auto',
              marginTop:'0.5em',
              borderRadius:'12px',
              background:'#fff',
              border:'2px solid #e3f2fd',
              boxShadow:'0 2px 12px rgba(25, 118, 210, 0.08)'
            }}>
              {usuariosFiltrados.map(u => (
                <label key={u._id} style={{
                  display:'flex',
                  alignItems:'center',
                  gap:'0.5em',
                  fontWeight:500,
                  padding:'0.6em 1.2em',
                  cursor:'pointer',
                  transition:'background 0.2s',
                  borderBottom:'1px solid #f5f5f5',
                  boxSizing:'border-box'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#e3f2fd'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                >
                  <input
                    type="checkbox"
                    checked={usuariosFiltro.includes(u._id)}
                    onChange={e => {
                      if (e.target.checked) {
                        setUsuariosFiltro([...usuariosFiltro, u._id]);
                      } else {
                        setUsuariosFiltro(usuariosFiltro.filter(id => id !== u._id));
                      }
                    }}
                    style={{width:16,height:16,cursor:'pointer',flexShrink:0}}
                  />
                  <span style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',color:'#1e293b'}}>{u.nombre} {u.apellidos}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:'1.2em',width:'100%'}}>
          <div style={{display:'flex',flexWrap:'wrap',gap:'1em',width:'100%'}}>
            <div style={{flex:'1 1 140px',minWidth:0}}>
              <label style={{fontWeight:600,color:'#1976d2',display:'block',marginBottom:'0.5em',fontSize:'1.05em'}}>
                📅 Desde:
              </label>
              <input 
                type="date" 
                value={desde} 
                onChange={e => setDesde(e.target.value)} 
                style={{
                  width:'100%',
                  padding:'0.7em 0.8em',
                  borderRadius:10,
                  border:'2px solid #90caf9',
                  fontFamily,
                  fontSize:'1rem',
                  transition:'all 0.3s',
                  outline:'none',
                  boxSizing:'border-box'
                }}
                onFocus={(e) => e.target.style.borderColor = '#1976d2'}
                onBlur={(e) => e.target.style.borderColor = '#90caf9'}
              />
            </div>
            <div style={{flex:'1 1 140px',minWidth:0}}>
              <label style={{fontWeight:600,color:'#1976d2',display:'block',marginBottom:'0.5em',fontSize:'1.05em'}}>
                📅 Hasta:
              </label>
              <input 
                type="date" 
                value={hasta} 
                onChange={e => setHasta(e.target.value)} 
                style={{
                  width:'100%',
                  padding:'0.7em 0.8em',
                  borderRadius:10,
                  border:'2px solid #90caf9',
                  fontFamily,
                  fontSize:'1rem',
                  transition:'all 0.3s',
                  outline:'none',
                  boxSizing:'border-box'
                }}
                onFocus={(e) => e.target.style.borderColor = '#1976d2'}
                onBlur={(e) => e.target.style.borderColor = '#90caf9'}
              />
            </div>
          </div>
          <button 
            onClick={consultar} 
            style={{
              padding:'0.8em 1.5em',
              borderRadius:12,
              border:'3px solid transparent',
              background:'linear-gradient(white, white) padding-box, linear-gradient(135deg, #1976d2 0%, #42a5f5 100%) border-box',
              color:'#1976d2',
              fontWeight:700,
              fontSize:'1.05rem',
              boxShadow:'0 4px 12px rgba(25, 118, 210, 0.2)',
              fontFamily,
              cursor:'pointer',
              transition:'all 0.3s',
              boxSizing:'border-box',
              width:'100%'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(25, 118, 210, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(25, 118, 210, 0.2)';
            }}
          >
            🔍 Buscar fichajes
          </button>
        </div>
      </div>
      <div className="ia-action-bar" style={{
        marginBottom:'1.5em',
        display:'flex',
        flexWrap:'wrap',
        gap:'1em',
        alignItems:'center',
        justifyContent:'center',
        background:'linear-gradient(135deg, rgba(56, 142, 60, 0.05) 0%, rgba(129, 199, 132, 0.08) 100%)',
        padding:'1.2em',
        borderRadius:'16px',
        border:'2px solid rgba(56, 142, 60, 0.15)'
      }}>
        <div className="ia-action-bar-inner" style={{display:'flex',gap:'0.8em',flexWrap:'wrap',alignItems:'center'}}>
          <label style={{fontWeight:600,color:'#388e3c',fontSize:'1.05em'}}>📄 Formato:</label>
          <select 
            value={formato} 
            onChange={e => setFormato(e.target.value)} 
            style={{
              padding:'0.6em 1em',
              borderRadius:10,
              border:'2px solid #81c784',
              fontFamily,
              fontSize:'1rem',
              fontWeight:600,
              cursor:'pointer',
              background:'white',
              transition:'all 0.3s'
            }}
            onFocus={(e) => e.target.style.borderColor = '#388e3c'}
            onBlur={(e) => e.target.style.borderColor = '#81c784'}
          >
            <option value="pdf">PDF</option>
            <option value="excel">Excel</option>
          </select>
          <label style={{fontWeight:600,color:'#388e3c',fontSize:'1.05em'}}>📊 Tipo:</label>
          <select 
            value={tipoInforme} 
            onChange={e => setTipoInforme(e.target.value)} 
            style={{
              padding:'0.6em 1em',
              borderRadius:10,
              border:'2px solid #81c784',
              fontFamily,
              fontSize:'1rem',
              fontWeight:600,
              cursor:'pointer',
              background:'white',
              transition:'all 0.3s'
            }}
            onFocus={(e) => e.target.style.borderColor = '#388e3c'}
            onBlur={(e) => e.target.style.borderColor = '#81c784'}
          >
            <option value="legal">Auditoría legal</option>
            <option value="admin">Informe detallado admin</option>
          </select>
        </div>
        <button 
          onClick={() => { setExportDesde(desde); setExportHasta(hasta); setExportModal(true); }} 
          style={{
            padding:'0.8em 1.8em',
            borderRadius:12,
            border:'3px solid transparent',
            background:'linear-gradient(white, white) padding-box, linear-gradient(135deg, #388e3c 0%, #66bb6a 100%) border-box',
            color:'#388e3c',
            fontWeight:700,
            fontSize:'1.05rem',
            boxShadow:'0 4px 12px rgba(56, 142, 60, 0.2)',
            fontFamily,
            cursor:'pointer',
            transition:'all 0.3s'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(56, 142, 60, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 12px rgba(56, 142, 60, 0.2)';
          }}
        >
          📥 Exportar informe
        </button>
        {fichajes.length > 0 && (
          <button
            onClick={() => setMapaModal(true)}
            style={{
              padding:'0.8em 1.8em',
              borderRadius:12,
              border:'3px solid transparent',
              background:'linear-gradient(white, white) padding-box, linear-gradient(135deg, #1565c0 0%, #1976d2 100%) border-box',
              color:'#1565c0',
              fontWeight:700,
              fontSize:'1.05rem',
              boxShadow:'0 4px 12px rgba(21, 101, 192, 0.2)',
              fontFamily,
              cursor:'pointer',
              transition:'all 0.3s'
            }}
          >
            🗺️ Ver en mapa
          </button>
        )}
      </div>

      {/* Modal mapa de fichajes */}
      {mapaModal && (
        <div
          onClick={() => setMapaModal(false)}
          style={{
            position:'fixed',inset:0,zIndex:4000,
            background:'rgba(10,20,40,0.7)',
            backdropFilter:'blur(6px)',
            display:'flex',alignItems:'center',justifyContent:'center',
            padding:'1em'
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background:'#fff',
              borderRadius:20,
              boxShadow:'0 24px 80px rgba(0,0,0,0.35)',
              width:'min(98vw, 900px)',
              maxHeight:'92vh',
              display:'flex',flexDirection:'column',
              overflow:'hidden'
            }}
          >
            {/* Header modal */}
            <div style={{
              padding:'1em 1.4em',
              display:'flex',alignItems:'center',justifyContent:'space-between',
              borderBottom:'2px solid #e3f2fd',
              background:'linear-gradient(135deg,rgba(25,118,210,0.06) 0%,rgba(144,202,249,0.10) 100%)'
            }}>
              <div style={{fontWeight:800,fontSize:'1.15em',color:'#1976d2',display:'flex',alignItems:'center',gap:'0.5em'}}>
                🗺️ Mapa de fichajes
                <span style={{fontSize:'0.8em',fontWeight:600,color:'#64748b',marginLeft:'0.3em'}}>
                  ({fichajes.filter(f=>f.ubicacion&&f.ubicacion.latitud!=null&&!f.ubicacion.error).length} con GPS)
                </span>
              </div>
              <button
                onClick={() => setMapaModal(false)}
                style={{
                  width:36,height:36,borderRadius:'50%',border:'2px solid #cbd5e1',
                  background:'#f8fafc',color:'#475569',fontWeight:800,fontSize:'1.1em',
                  cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',
                  transition:'all 0.2s',flexShrink:0
                }}
                onMouseEnter={e=>{e.target.style.background='#e2e8f0';}}
                onMouseLeave={e=>{e.target.style.background='#f8fafc';}}
              >✕</button>
            </div>
            {/* Leyenda */}
            <div style={{
              padding:'0.7em 1.4em',
              display:'flex',flexWrap:'wrap',gap:'1em',alignItems:'center',
              fontSize:'0.88em',borderBottom:'1px solid #f1f5f9',background:'#fafcff'
            }}>
              <span>🟢 Entrada</span>
              <span>🔴 Salida</span>
              <span>🏢 Empresa</span>
              <span style={{color:'#f59e0b',fontWeight:600}}>⚠️ Fuera de margen</span>
              <span style={{color:'#b45309',fontWeight:600}}>📍 Sin GPS</span>
              <span style={{marginLeft:'auto',color:'#94a3b8'}}>
                {fichajes.filter(f=>f.ubicacion&&!f.ubicacion.error&&f.ubicacion.latitud!=null).length} de {fichajes.length} fichajes con ubicación
              </span>
            </div>
            {/* Mapa */}
            <div style={{flex:1,minHeight:400,overflow:'hidden'}}>
              <MapaFichajes fichajes={fichajes} settings={settingsEmpresa} />
            </div>
          </div>
        </div>
      )}
      {fichajes.length === 0 && (
        <div style={{
          textAlign:'center',
          color:'#64748b',
          fontSize:'1.15em',
          marginTop:'3em',
          padding:'2em',
          background:'linear-gradient(135deg, rgba(100, 116, 139, 0.05) 0%, rgba(148, 163, 184, 0.08) 100%)',
          borderRadius:'16px',
          border:'2px dashed rgba(100, 116, 139, 0.2)'
        }}>
          📋 No hay fichajes en el periodo seleccionado
        </div>
      )}
      {Object.entries(groupByDay(fichajes)).map(([dia, fichajesDia], idx) => (
        <div key={dia} style={{marginBottom:'2em'}}>
          <div className="ia-day-label" style={{
            fontWeight:700,
            color:'#1976d2',
            fontSize:'1.2em',
            marginBottom:'1em',
            fontFamily,
            padding:'0.5em 1em',
            background:'linear-gradient(135deg, rgba(25, 118, 210, 0.08) 0%, rgba(66, 165, 245, 0.12) 100%)',
            borderRadius:'12px',
            border:'2px solid rgba(25, 118, 210, 0.2)',
            display:'inline-block'
          }}>
            📅 {dia}
          </div>
          <div className="ia-cards-grid" style={{
            display:'grid',
            gridTemplateColumns:'repeat(auto-fill, minmax(min(100%, 300px), 1fr))',
            gap:'1em'
          }}>
            {[...fichajesDia].sort((a, b) => new Date(b.fecha) - new Date(a.fecha)).map((f, i) => {
              const esLegal = tipoInforme === 'legal';
              const sinGps = !f.ubicacion || !!f.ubicacion?.error;
              const fueraMargen = !esLegal && (
                (f.ubicacion?.distanciaEmpresa != null && f.ubicacion?.dentroDelMargen === false) ||
                sinGps
              );
              const esAlerta = !esLegal && f.registro_desconocido;
              const tarjetaBg = (fueraMargen || esAlerta)
                ? 'linear-gradient(135deg, #fffbeb 0%, #fef9c3 100%)'
                : (f.tipo==='entrada' ? 'linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%)' : 'linear-gradient(135deg, #ffebee 0%, #fce4ec 100%)');
              const tarjetaBorder = (fueraMargen || esAlerta)
                ? '6px solid #f59e0b'
                : (f.tipo==='entrada' ? '6px solid #4caf50' : '6px solid #f44336');
              const tarjetaShadow = (fueraMargen || esAlerta)
                ? '0 4px 24px rgba(245,158,11,0.28)'
                : (f.tipo==='entrada' ? '0 4px 20px rgba(76, 175, 80, 0.12)' : '0 4px 20px rgba(244, 67, 54, 0.12)');
              return (
                <div key={f._id} style={{
                  background: tarjetaBg,
                  borderLeft: tarjetaBorder,
                  borderRadius: 16,
                  boxShadow: tarjetaShadow,
                  padding: '1.2em 1.4em',
                  fontFamily,
                  display:'flex',
                  flexDirection:'column',
                  gap:'0.6em',
                  position:'relative',
                  transition:'all 0.3s',
                  cursor:'pointer',
                  overflow:'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = (fueraMargen || esAlerta)
                    ? '0 8px 32px rgba(251,192,45,0.3)'
                    : (f.tipo==='entrada' ? '0 8px 32px rgba(76, 175, 80, 0.2)' : '0 8px 32px rgba(244, 67, 54, 0.2)');
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = tarjetaShadow;
                }}
                >
                  {/* Banner de aviso ubicación */}
                  {fueraMargen && (
                    <div style={{
                      margin: '-1.2em -1.4em 0.4em',
                      padding: '0.45em 1.2em',
                      background: sinGps
                        ? 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)'
                        : 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                      color: '#7c2d12',
                      fontWeight: 700,
                      fontSize: '0.82em',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5em',
                      letterSpacing: '0.01em'
                    }}>
                      {sinGps ? '📍 Sin ubicación GPS' : '⚠️ Fuera del margen permitido'}
                    </div>
                  )}
                  <div style={{display:'flex',alignItems:'center',gap:'0.8em',flexWrap:'wrap',position:'relative'}}>
                    <span style={{fontSize:32}}>{f.tipo==='entrada' ? '🟢' : '🔴'}</span>
                    <span style={{fontWeight:700,fontSize:'1.15em',color:'#1e293b',flex:1}}>{f.usuario?.nombre} {f.usuario?.apellidos}</span>
                    {!esLegal && f.registro_desconocido && (
                      <span
                        title="Dispositivo distinto al habitual"
                        style={{color:'#f44336',fontSize:28,cursor:'pointer',transition:'transform 0.2s'}}
                        onClick={(e) => { e.stopPropagation(); setInfoIdx(`${dia}-${i}`); }}
                        onMouseEnter={(e) => e.target.style.transform = 'scale(1.2) rotate(15deg)'}
                        onMouseLeave={(e) => e.target.style.transform = 'scale(1) rotate(0deg)'}
                      >⚠️</span>
                    )}
                    {!esLegal && infoIdx === `${dia}-${i}` && (
                      <>
                        <style>{warningAnim}</style>
                        <div style={{
                          position:'fixed',
                          top:'50%',
                          left:'50%',
                          transform:'translate(-50%, -50%)',
                          zIndex:2000,
                          background:'#fffbe6',
                          border:'3px solid #fbc02d',
                          borderRadius:20,
                          boxShadow:'0 20px 60px rgba(251,192,45,0.3)',
                          padding:'1.5em 2em',
                          minWidth:'min(90vw, 380px)',
                          maxWidth:'90vw',
                          textAlign:'center',
                          fontFamily,
                          animation:'warningFade 0.5s cubic-bezier(.4,0,.2,1)'
                        }}
                        onClick={(e) => e.stopPropagation()}
                        >
                          <div style={{color:'#f44336',fontWeight:700,fontSize:'1.3em',marginBottom:'0.8em'}}>⚠️ Dispositivo Diferente</div>
                          <div style={{color:'#333',fontSize:'1.05em',marginBottom:'1.2em',lineHeight:1.6}}>
                            Este fichaje se realizó desde un dispositivo diferente al habitual del usuario.
                            <br/><br/>
                            Verifica si es correcto o requiere validación adicional.
                          </div>
                          <button
                            style={{
                              padding:'0.7em 2em',
                              borderRadius:12,
                              border:'3px solid transparent',
                              background:'linear-gradient(white, white) padding-box, linear-gradient(135deg, #f44336 0%, #e91e63 100%) border-box',
                              color:'#f44336',
                              fontWeight:700,
                              fontFamily,
                              cursor:'pointer',
                              fontSize:'1.05rem',
                              transition:'all 0.3s'
                            }}
                            onClick={(e) => { e.stopPropagation(); setInfoIdx(null); }}
                            onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                          >
                            Cerrar
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                  <div style={{fontWeight:700,fontSize:'1.1em',color:'#1e293b'}}>
                    {f.tipo==='entrada' ? '➡️ Entrada' : '⬅️ Salida'} - {new Date(f.fecha).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    {f.tipo==='salida' && typeof f.duracion === 'number' && (
                      <span style={{ color: '#1976d2', fontWeight: 600, marginLeft: 8, fontSize: '0.95em' }}>
                        {' ('}
                        {`${Math.floor(Math.abs(f.duracion)/60)}h ${Math.abs(f.duracion)%60}min`}
                        {')'}
                      </span>
                    )}
                  </div>
                  <div style={{fontSize:'0.95em',color:'#475569',display:'flex',flexDirection:'column',gap:'0.3em'}}>
                    <div>
                      <strong>💻 Dispositivo:</strong>{' '}
                      {(f.dispositivo?.marca || f.dispositivo?.modelo)
                        ? <>{f.dispositivo?.marca || '-'} {f.dispositivo?.modelo || '-'}</>
                        : (f.dispositivo?.userAgent
                            ? <span title={f.dispositivo?.userAgent} style={{fontSize:'0.9em',color:'#64748b'}}>{f.dispositivo?.userAgent.substring(0, 40)}...</span>
                            : '-')}
                    </div>
                    <div>
                      <strong>🖥️ SO:</strong> {f.dispositivo?.so || '-'} 
                      <span style={{marginLeft:'1em'}}><strong>🌐 IP:</strong> {f.dispositivo?.ip || '-'}</span>
                    </div>
                    {/* Distancia a empresa */}
                    {f.ubicacion && !f.ubicacion.error && f.ubicacion.distanciaEmpresa != null && (
                      <div style={{
                        marginTop:'0.3em',
                        padding:'0.4em 0.7em',
                        borderRadius:8,
                        background: f.ubicacion.dentroDelMargen
                          ? 'rgba(76,175,80,0.12)'
                          : 'rgba(251,192,45,0.18)',
                        border: f.ubicacion.dentroDelMargen
                          ? '1px solid rgba(76,175,80,0.3)'
                          : '1px solid rgba(251,192,45,0.5)',
                        color: f.ubicacion.dentroDelMargen ? '#2e7d32' : '#7c4a00',
                        fontWeight: 700,
                        fontSize:'0.9em',
                        display:'flex',gap:'0.5em',alignItems:'center',flexWrap:'wrap'
                      }}>
                        {f.ubicacion.dentroDelMargen ? '✅' : '⚠️'}
                        <span>
                          {f.ubicacion.distanciaEmpresa >= 1000
                            ? `${(f.ubicacion.distanciaEmpresa / 1000).toFixed(2)} km`
                            : `${f.ubicacion.distanciaEmpresa} m`}
                          {' de la empresa'}
                          {!f.ubicacion.dentroDelMargen && ' · fuera del margen'}
                        </span>
                      </div>
                    )}
                    {f.ubicacion?.error && (
                      <div style={{
                        marginTop:'0.3em',padding:'0.35em 0.7em',borderRadius:8,
                        background:'rgba(251,192,45,0.15)',border:'1px solid rgba(251,192,45,0.4)',
                        color:'#7c4a00',fontWeight:600,fontSize:'0.88em'
                      }}>
                        📍 Sin GPS: {f.ubicacion.error}
                      </div>
                    )}
                    {!f.ubicacion && (
                      <div style={{
                        marginTop:'0.3em',padding:'0.35em 0.7em',borderRadius:8,
                        background:'rgba(251,192,45,0.15)',border:'1px solid rgba(251,192,45,0.4)',
                        color:'#7c4a00',fontWeight:600,fontSize:'0.88em'
                      }}>
                        📍 Sin ubicación registrada
                      </div>
                    )}
                  </div>
                  <div style={{fontSize:'0.9em',color:'#94a3b8',marginTop:'0.3em',paddingTop:'0.5em',borderTop:'1px solid rgba(0,0,0,0.08)'}}>
                    🕐 {new Date(f.fecha).toLocaleDateString()} • {new Date(f.fecha).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
      {exportModal && (
        <div
          onClick={() => !exportando && setExportModal(false)}
          style={
            {
            position: 'fixed', inset: 0, zIndex: 3000,
            background: 'rgba(10,20,40,0.55)',
            backdropFilter: 'blur(4px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#fff',
              borderRadius: 24,
              boxShadow: '0 24px 64px rgba(25,118,210,0.22)',
              padding: '2em 2.2em',
              minWidth: 'min(92vw, 380px)',
              maxWidth: '92vw',
              fontFamily,
              display: 'flex', flexDirection: 'column', gap: '1.4em'
            }}
          >
            {exportando ? (
              <>
                <style>{`@keyframes iaSpinRing { to { transform: rotate(360deg); } }`}</style>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.2em', padding: '1em 0' }}>
                  <div style={{
                    width: 56, height: 56,
                    border: '5px solid #e3f2fd',
                    borderTop: '5px solid #388e3c',
                    borderRadius: '50%',
                    animation: 'iaSpinRing 0.8s linear infinite'
                  }} />
                  <div style={{ fontWeight: 700, fontSize: '1.15em', color: '#388e3c' }}>Exportando datos...</div>
                  <div style={{ color: '#64748b', fontSize: '0.95em', textAlign: 'center' }}>Generando el informe, por favor espera.</div>
                </div>
              </>
            ) : (
              <>
                <div style={{ fontWeight: 800, fontSize: '1.3em', color: '#1976d2', textAlign: 'center' }}>
                  📥 Exportar informe
                </div>
                <div style={{ color: '#475569', fontSize: '0.97em', textAlign: 'center', marginTop: '-0.6em' }}>
                  Selecciona el rango de fechas a exportar.<br/>Si no seleccionas fechas se exportarán todos los registros.
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
                  <div>
                    <label style={{ fontWeight: 700, color: '#1976d2', display: 'block', marginBottom: '0.4em' }}>📅 Desde:</label>
                    <input
                      type="date"
                      value={exportDesde}
                      onChange={e => setExportDesde(e.target.value)}
                      style={{
                        width: '100%', padding: '0.7em 1em', borderRadius: 10,
                        border: '2px solid #90caf9', fontFamily, fontSize: '1rem',
                        outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s'
                      }}
                      onFocus={e => e.target.style.borderColor = '#1976d2'}
                      onBlur={e => e.target.style.borderColor = '#90caf9'}
                    />
                  </div>
                  <div>
                    <label style={{ fontWeight: 700, color: '#1976d2', display: 'block', marginBottom: '0.4em' }}>📅 Hasta:</label>
                    <input
                      type="date"
                      value={exportHasta}
                      onChange={e => setExportHasta(e.target.value)}
                      style={{
                        width: '100%', padding: '0.7em 1em', borderRadius: 10,
                        border: '2px solid #90caf9', fontFamily, fontSize: '1rem',
                        outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s'
                      }}
                      onFocus={e => e.target.style.borderColor = '#1976d2'}
                      onBlur={e => e.target.style.borderColor = '#90caf9'}
                    />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '0.8em', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <button
                    onClick={() => setExportModal(false)}
                    style={{
                      padding: '0.7em 1.5em', borderRadius: 10,
                      border: '2px solid #cbd5e1', background: '#f8fafc',
                      color: '#64748b', fontWeight: 700, fontFamily, fontSize: '1rem',
                      cursor: 'pointer', transition: 'all 0.2s'
                    }}
                    onMouseEnter={e => e.target.style.background = '#e2e8f0'}
                    onMouseLeave={e => e.target.style.background = '#f8fafc'}
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={() => { exportar(exportDesde, exportHasta); }}
                    style={{
                      padding: '0.7em 1.8em', borderRadius: 10,
                      border: '3px solid transparent',
                      background: 'linear-gradient(white, white) padding-box, linear-gradient(135deg, #388e3c 0%, #66bb6a 100%) border-box',
                      color: '#388e3c', fontWeight: 700, fontFamily, fontSize: '1rem',
                      cursor: 'pointer', transition: 'all 0.2s', boxShadow: '0 4px 12px rgba(56,142,60,0.15)'
                    }}
                    onMouseEnter={e => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 6px 20px rgba(56,142,60,0.25)'; }}
                    onMouseLeave={e => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 12px rgba(56,142,60,0.15)'; }}
                  >
                    📥 Descargar
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default InformeAdmin;
